import axios, {AxiosResponse} from 'axios';
import {
  IArticleAuthor, IArticleCollection,
  IArticleReference,
  IArticleReferenceDescr,
  IArticleSection, IArticleTable,
  ITeiArticle
} from '../article/interfaces';

export const getTeiArticleApi = (id: string): Promise<AxiosResponse<ITeiArticle>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/page/${id}`);
};

export const getTeiArticleAuthorsApi = (id: string): Promise<AxiosResponse<IArticleAuthor[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/authors/${id}`);
};

export const getTeiReferenceAuthorsApi = (articleId: string, referenceId: string): Promise<AxiosResponse<IArticleAuthor[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/reference/authors/${articleId}/${referenceId}`);
};

export const getTeiArticleReferencesApi = (id: string): Promise<AxiosResponse<IArticleReferenceDescr[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/references/${id}`);
};

export const getTeiArticleSectionsApi = (id: string): Promise<AxiosResponse<IArticleSection[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/sections/${id}`);
};

export const getTeiArticleCollectionsApi = (id: string): Promise<AxiosResponse<IArticleCollection[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/collections/${id}`);
};

export const getTeiArticleTablesApi = (id: string): Promise<AxiosResponse<IArticleTable[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/tables/${id}`);
};

export const getTeiArticleReferenceApi = (articleId: string, referenceId: string): Promise<AxiosResponse<IArticleReference>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/reference/${articleId}/${referenceId}`);
};

export const getTeiSectionSectionApi = (articleId: string, sectionIndex: string): Promise<AxiosResponse<IArticleSection>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/article/section/${articleId}/${sectionIndex}`);
};

export const getArticlePdfApi = async (articleId: number): Promise<AxiosResponse<{ value: string }>> => {
  return axios.get<{ value: string }>(`${process.env.REACT_APP_API_URL}/article/download/pdf/${articleId}`);
};
